module.exports = __webpack_public_path__ + "28bbf24261831c20324c08fe2ec8e21d.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/DoOoOoBa.jpg
// module id = 610
// module chunks = 30